import { I18n } from "@assets/strings";
import React from "react";
import { NotFoundPage } from "@ui/pages/notFoundPage";
//import { GroupLivecoursesEditor, OrganizationLivecoursesEditor } from "./livecoursesEditor";
import { addHours } from "date-fns";
import { getLivecourseInfos } from "@domain/livecourse/hooks";
import { Livecourse, LivecourseType } from "@domain/livecourse/livecourse";
import { GroupLivecoursesEditor } from "@ui/pages/livecourses/livecoursesEditor/groupLivecoursesEditor";
import { OrganizationLivecoursesEditor } from "@ui/pages/livecourses/livecoursesEditor/organizationLivecoursesEditor";

interface GroupLivecourseEditPageProps extends React.HTMLAttributes<HTMLDivElement> {
	livecourseId?: string;
	shareroomId: string;
	type: LivecourseType;
}
export const GroupLivecourseEditPage: React.FC<GroupLivecourseEditPageProps> = ({
	livecourseId,
	type,
	shareroomId,
	...htmlProps
}) => {
	return livecourseId ? (
		<GroupLivecourseUpdatePage type={type} shareroomId={shareroomId} livecourseId={livecourseId} {...htmlProps} />
	) : (
		<GroupLivecourseCreationPage type={type} shareroomId={shareroomId} {...htmlProps} />
	);
};

interface OrganizationLivecourseEditPageProps extends React.HTMLAttributes<HTMLDivElement> {
	livecourseId?: string;
	organizationId: string;
	type: LivecourseType;
}
export const OrganizationLivecourseEditPage: React.FC<OrganizationLivecourseEditPageProps> = ({
	livecourseId,
	type,
	organizationId,
	...htmlProps
}) => {
	return livecourseId ? (
		<OrganizationLivecourseUpdatePage
			type={type}
			organizationId={organizationId}
			livecourseId={livecourseId}
			{...htmlProps}
		/>
	) : (
		<OrganizationLivecourseCreationPage type={type} organizationId={organizationId} {...htmlProps} />
	);
};

interface GroupLivecourseUpdatePageProps extends React.HTMLAttributes<HTMLDivElement> {
	livecourseId: string;
	shareroomId: string;
	type?: LivecourseType;
}
const GroupLivecourseUpdatePage: React.FC<GroupLivecourseUpdatePageProps> = ({ livecourseId, shareroomId, type }) => {
	const { result: livecourse, loading, error } = getLivecourseInfos(livecourseId);
	if (error?.code === 404) {
		return <NotFoundPage message={I18n.t("404.quiz")} />;
	}
	return loading ? (
		<></>
	) : (
		livecourse && <GroupLivecoursesEditor type={type} initialLivecourse={livecourse} shareroomId={shareroomId} />
	);
};

interface GroupLivecourseCreatePageProps extends React.HTMLAttributes<HTMLDivElement> {
	type: LivecourseType;
	shareroomId: string;
}
const GroupLivecourseCreationPage: React.FC<GroupLivecourseCreatePageProps> = ({ type, shareroomId, ...htmlProps }) => {
	const initialLivecourse = {
		organizer: "",
		title: "",
		description: "",
		workspaceId: "",
		startDate: new Date(),
		endDate: addHours(new Date(), 2),
		postAutoPublish: true,
	};
	return (
		<GroupLivecoursesEditor
			initialLivecourse={initialLivecourse as Livecourse}
			type={type}
			shareroomId={shareroomId}
			{...htmlProps}
		/>
	);
};

interface OrganizationLivecourseCreatePageProps extends React.HTMLAttributes<HTMLDivElement> {
	type: LivecourseType;
	organizationId: string;
}
const OrganizationLivecourseCreationPage: React.FC<OrganizationLivecourseCreatePageProps> = ({
	type,
	organizationId,
	...htmlProps
}) => {
	const initialLivecourse = {
		organizer: "",
		title: "",
		description: "",
		workspaceId: "",
		startDate: new Date(),
		endDate: addHours(new Date(), 2),
		postAutoPublish: true,
	};
	return (
		<OrganizationLivecoursesEditor
			initialLivecourse={initialLivecourse as Livecourse}
			type={type}
			organizationId={organizationId}
			{...htmlProps}
		/>
	);
};

interface OrganizationLivecourseUpdatePageProps extends React.HTMLAttributes<HTMLDivElement> {
	livecourseId: string;
	organizationId: string;
	type: LivecourseType;
}
const OrganizationLivecourseUpdatePage: React.FC<OrganizationLivecourseUpdatePageProps> = ({
	livecourseId,
	type,
	organizationId,
}) => {
	const { result: livecourse, loading, error } = getLivecourseInfos(livecourseId);

	if (error?.code === 404) {
		return <NotFoundPage message={I18n.t("404.quiz")} />;
	}
	return loading ? (
		<> </>
	) : (
		livecourse && (
			<OrganizationLivecoursesEditor type={type} initialLivecourse={livecourse} organizationId={organizationId} />
		)
	);
};
